import { render, staticRenderFns } from "./GoldMallActivityModal.vue?vue&type=template&id=bd84dac0&"
import script from "./GoldMallActivityModal.vue?vue&type=script&lang=js&"
export * from "./GoldMallActivityModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports